import * as React from "react";
import { twMerge } from "tailwind-merge";

export type CardProps = React.HTMLAttributes<HTMLDivElement> & {
  as?: React.ElementType;
};

export default function Card({ as, className, children, ...rest }: CardProps) {
  const Comp = (as ?? "section") as React.ElementType;
  return (
    <Comp
      className={twMerge("rounded-[8px] p-[20px] bg-surface", className)}
      {...rest}
    >
      {children}
    </Comp>
  );
}
